export default function createUniversalCookie() {
    return new UniversalCookie();
}